export default {
      id: "plant-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "icons.svg#plant",
      toString: function () {
        return this.url;
      }
    }